export default function (props) {
    return (<div className="c-sportroute-tags">
        {props.items?.map((item, index) => (
            <div className="c-sportroute-tag" key={item.text} title={item.title}>{item.text}</div>
        ))}
    </div>)

}